import { Bex } from "./bex.model";
import { Kodiak } from "./kodiak.model";
import { OogaBooga } from "./ooga-booga.model";
import { BurrBear } from "./burrbear.model";

export default {
  Bex,
  Kodiak,
  "Ooga Booga": OogaBooga,
  BurrBear
} as { [key: string]: any };
